"use client"
import { NftsToBuyMoleculeReatom } from "@/app/nft/buy/nfts-to-buy/molecule.reatom"
import { NftSelectionScope } from "@/app/nft/nft-selection/nft-selection-scope"
import type { NftMiniature } from "@anaconda/core/nft/types"
import { atom } from "@reatom/core"
import { reatomComponent, useWrap } from "@reatom/react"
import { ScopeProvider, useMolecule } from "bunshi/react"
import { useEffect, useMemo } from "react"

interface Props {
  children: React.ReactNode
  nft: NftMiniature
}

export const NftSelectionScopeProvider = reatomComponent<Props>(
  ({ children, nft }) => {
    const nftAtom = useNftAtom(nft)
    const { isNftSelectable } = useMolecule(NftsToBuyMoleculeReatom)

    return (
      <ScopeProvider
        scope={NftSelectionScope}
        value={{ nftAtom, isSelectable: isNftSelectable }}
      >
        {children}
      </ScopeProvider>
    )
  },
  "NftSelectionScopeProvider",
)

function useNftAtom(nft: NftMiniature) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: Create atom once, update via .set()
  const nftAtom = useMemo(() => atom(nft, "scopedNft"), [])

  const setNft = useWrap(() => {
    nftAtom.set(nft)
  })

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    setNft()
  }, [nft, setNft])

  return nftAtom
}
